// INSPECTIONS
export const GET_INSPECTIONS = '/inspections/';
export const GET_INSPECTIONS_QUERY = '/inspections/query';
export const GET_INSPECTION = '/inspections/';
export const POST_INSPECTION = '/inspections/';
export const PUT_INSPECTION = '/inspections/';
export const DELETE_INSPECTION = '/inspections/';

// DASHBOARD
export const GET_DASHBOARD_SUMMARY = '/dashboard/summary';
export const GET_INSPECTIONS_BY_AUTHORITY_YEAR = '/dashboard/inspections-by-authority-year';
